import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Avatar,
  Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ListItem, Button } from '@mui/material';

import User from 'src/assets/user_icon.png';
import Logo from './Logo';
import Collapsable from './Collapsable';

const DashboardNavbar = ({ onMobileNavOpen, logout, loading, ...rest }) => {
  const { user } = useSelector((state) => state.common);
  const [open, setOpen] = useState(false);
  
  const popOverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popOverRef.current && !popOverRef.current.contains(event.target)) {
        setOpen(false);
      } 
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const logo = { height: 40, width: 40, borderRadius: '50%' };
  return (
    <AppBar elevation={0} {...rest}>
      <Toolbar>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <RouterLink to="/">
          <Logo style={logo} />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex'
          }}
        >
          <ListItem>
            <Button
              component={RouterLink}
              sx={{
                color: 'text.secondary',
                fontWeight: 'medium',
                alignSelf: 'flex-end',
                letterSpacing: 0,
                textTransform: 'none',
                width: '100%'
              }}
            >
              <div
                style={{
                  display: 'flex'
                }}
              >
                <div ref={popOverRef} style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    onClick={(e) => {
                      setOpen((prev) => !prev)
                    }}
                    src={user.profile_pic || User}
                    sx={{
                      cursor: 'pointer',
                      width: 35,
                      height: 35,
                      background:"white"
                    }}
                    to="#"
                  />
                  <Box sx={{ marginLeft: '1rem' }}>
                    <Typography
                      color="white"
                      sx={{ fontSize: '.7rem' }}
                      variant="h6"
                    >
                      {user.full_name.length >= 20
                        ? user.full_name.slice(0, 17) + '...'
                        : user.full_name}
                    </Typography>
                    <Typography
                      color="white"
                      sx={{ fontSize: '.7rem' }}
                      variant="body2"
                    >
                      {user.email.length >= 20
                        ? user.email.slice(0, 17) + '...'
                        : user.email}
                    </Typography>
                  </Box>
                </div>
                <div>{}</div>
              </div>
            </Button>
          </ListItem>
        </Box>
        <Collapsable open={open} setOpen={setOpen} />
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
